import Dropdown from "../../components/Dropdown";
import TooltipBox from "../../components/Tooltip";
import InputDataControl from "./InputDataControl";
import { CENTRAL_CATALOG_AMBITO_TEXT } from "../js/constants";

const ambitoText = (ambito) =>
  CENTRAL_CATALOG_AMBITO_TEXT[ambito] ?? CENTRAL_CATALOG_AMBITO_TEXT.L;

const ambitoIcon = (ambito) =>
  ambito === "E"
    ? "/images/support-extra/doslentes.svg"
    : "/images/support-extra/unalente.svg";

export default ({
  parametro,
  valor,
  onChange,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const isDesplegable = parametro.TipoValor === "Desplegable";

  const sinLimites = parametro.ValorMinimo === 0 && parametro.ValorMaximo === 0;
  const minValue = sinLimites ? "" : parametro.ValorMinimo;
  const maxValue = sinLimites ? "" : parametro.ValorMaximo;
  const step = parametro.Incrementos === 0 ? "" : parametro.Incrementos;
  const numDecimales =
    parametro.NumDecimales === 0 ? "" : parametro.NumDecimales;

  const opciones = [
    { value: "", text: "" },
    ...(parametro.Opciones ?? []).map((o) => ({
      value: o.CodigoOpcion,
      text: o.Opcion,
    })),
  ];

  return (
    <>
      <div className="catalog-parametro-title-row">
        <span className="section-content-title">{parametro.TipoParametro}</span>
        <img
          src={ambitoIcon(parametro.Ambito)}
          alt=""
          className="catalog-parametro-ambito-icon"
          data-tooltip-id={`ambito-${parametro.CodigoEdi}`}
        />
        <TooltipBox
          id={`ambito-${parametro.CodigoEdi}`}
          content={<div>{ambitoText(parametro.Ambito)}</div>}
        />
      </div>
      <div className="section-content-sep" />
      <div className="popup-row">
        <div className="label">
          {parametro.CodigoEdi} - {parametro.Nombre}
          {parametro.Requerido ? " (*)" : ""}
        </div>
        {isDesplegable ? (
          <Dropdown
            id={`param-${parametro.CodigoEdi}`}
            optionList={opciones}
            size={0}
            op={valor}
            onChange={(e) => onChange(e.value)}
            mandatory
          />
        ) : (
          <InputDataControl
            id={`param-${parametro.CodigoEdi}`}
            type="type-float"
            size={1}
            input={valor}
            onChange={onChange}
            minValue={minValue}
            maxValue={maxValue}
            step={step}
            numDecimales={numDecimales}
            createPopupQuestion={createPopupQuestion}
            removePopupQuestion={removePopupQuestion}
          />
        )}
        {parametro.UnidadesMedida && (
          <span className="popup-row-value">{parametro.UnidadesMedida}</span>
        )}
      </div>
    </>
  );
};
